import { useEffect, useState } from "react";
import TiltedGridHero from "./ui/tilted-grid-hero";
import MonogramSeal from "./MonogramSeal";
import { trackEvent } from "../analytics";

const BAND = [
  { src: "/cindy-450.webp", srcset: "/cindy-450.webp 450w, /cindy.webp 675w", sizes: "158px", alt: "Cindy Silva", op: "50% 18%", w: 450, h: 800 },
  { src: "/fumiga-card-450.webp", srcset: "/fumiga-card-450.webp 450w, /fumiga-card-900.webp 900w", sizes: "448px", alt: "Fumiga", w: 450, h: 281 },
  { src: "/certero-card-450.webp", srcset: "/certero-card-450.webp 450w, /certero-card-900.webp 900w", sizes: "448px", alt: "CERTERO", w: 450, h: 281 },
  { src: "/proj-ganadero-450.webp", srcset: "/proj-ganadero-450.webp 450w, /proj-ganadero.webp 900w", sizes: "448px", alt: "Portal Ganadero", w: 450, h: 282 },
  { src: "/priceclean-card-450.webp", srcset: "/priceclean-card-450.webp 450w, /priceclean-card-900.webp 900w", sizes: "448px", alt: "PriceClean Pro", w: 450, h: 281 },
  { src: "/crew-control-450.webp", srcset: "/crew-control-450.webp 450w, /crew-control-900.webp 900w", sizes: "448px", alt: "Cindyrella Crew + Control", w: 450, h: 225 },
];

const Hero = ({ t }) => {
  // Primer render siempre en versión escritorio (idéntico al HTML prerenderizado);
  // el ajusto a móvil ocurre después de hidratar para no romper la hidratación.
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 759px)");
    setMobile(mq.matches);
    const on = (e) => setMobile(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);

  return (
    <TiltedGridHero
      images={BAND}
      speed={5}
      axis={mobile ? 50 : 52}
      curve={mobile ? 20 : 80}
      tileHeight={mobile ? 30 : 26}
      flat={mobile}
      className="hero-tilted grain"
      data-testid="hero-tilted"
    >
      <div className="hero-seal-mark" aria-hidden="true">
        <MonogramSeal sealText={t.sealText} />
      </div>
      <div className="tgh-overlay">
        <div className="hero-content">
          <div className="hero-veil" aria-hidden="true" />
          <p className="eyebrow lt" data-testid="hero-eyebrow">
            <span className="eyebrow-rule" />
            {t.eyebrow}
          </p>
          <h1 data-testid="hero-headline">
            {t.headline.map((l, i) => (
              <span className="mask-line" key={i}>
                <span>{l.em ? <em>{l.t}</em> : l.t}</span>
              </span>
            ))}
          </h1>
          <p className="lead lt-2">{t.lead}</p>
          <div className="actions">
            <a className="btn-gold" href="#contact" data-testid="hero-primary-cta" onClick={() => trackEvent("cta_click", { texto: t.cta })}>
              {t.cta} <span className="arr">↗</span>
            </a>
            <a className="textlink lt" href="#work" data-testid="hero-secondary-cta">
              {t.seeWork} <span className="arr-down">↓</span>
            </a>
          </div>
        </div>
      </div>
      <div className="scroll-hint mono" aria-hidden="true">
        <span>{t.scroll}</span>
        <i />
      </div>
    </TiltedGridHero>
  );
};

export default Hero;
